import { yupResolver } from "@hookform/resolvers/yup";
import _ from "lodash";
import moment from "moment";
import { useForm } from "react-hook-form";
import { EntityAuthField } from "src/services/link/queries/NetTypes";

import useConnectService from "../services/useConnectAccount";
import { useFormSchema } from "./useFormSchema";
import { useRenderFields } from "./useRenderFields ";

interface UseDynamicFormProps {
	fields: EntityAuthField[];
	fieldSelected: string;
	isProduct?: boolean;
}

export const useDynamicForm = ({ fields, fieldSelected, isProduct }: UseDynamicFormProps) => {
	const {
		totpNeeded,
		isLoading,
		errorMessage,
		isSuccess,
		isError,
		userConfirmationNeeded,
		connectRequest,
		isUpdateFlow,
		isUnexpectedError
	} = useConnectService();

	const renderFields = useRenderFields(fields, fieldSelected);
	const schema = useFormSchema(
		fields,
		fieldSelected,
		totpNeeded,
		userConfirmationNeeded,
		isUpdateFlow
	);

	let defaultValues: { [key: string]: string | boolean | null } = {};

	renderFields.forEach((field) => (defaultValues[field.value] = ""));

	if (!isUpdateFlow && !isProduct) {
		defaultValues.storeCredentials = true;
	}

	if (renderFields.find((field) => field.value === "birthdate")) {
		defaultValues.birthdate = null;
	}

	const methods = useForm({
		resolver: yupResolver(schema),
		mode: "onSubmit",
		defaultValues
	});
	const onSubmit = (data: any) => {
		let valueParams: any = {};
		let selectedKey = "";
		if (fieldSelected) {
			const field = fields.find(
				(field) => field.visibility?.values?.find((i) => i === fieldSelected)
			);
			selectedKey = field?.name ?? "";
			valueParams = { login_type: fieldSelected, [selectedKey]: data[selectedKey] };
		}

		_.keys(data)
			.filter((k) => k !== selectedKey)
			.forEach((key) => {
				valueParams[key] = data[key];
			});

		if (valueParams.birthdate) {
			valueParams.birthdate = moment(valueParams.birthdate).format("YYYY-MM-DD");
		}

		connectRequest(valueParams, methods.reset);
	};

	return {
		methods,
		onSubmit: methods.handleSubmit(onSubmit),
		renderFields,
		errorMessage,
		isSuccess,
		isLoading,
		totpNeeded,
		userConfirmationNeeded,
		isError,
		isUnexpectedError
	};
};
